module.exports = "/images/bf.svg?b20f7b433fdbcae8c46b27e880c976cb";